// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-primary {
    background-color: #1F5186;
    border-color: #1F5186;
}

.btn-dark:hover {
    background: #007952;
    border-color: #007952;
}

.navbar.default-layout {
    font-family: "roboto", sans-serif;
    background: #fff;
    transition: background 0.25s ease;
    -webkit-transition: background 0.25s ease;
    -moz-transition: background 0.25s ease;
    -ms-transition: background 0.25s ease;
    box-shadow: 0 0 10px 0 rgb(255 255 255);
}

.navbar.default-layout .navbar-brand-wrapper {
    transition: width 0.25s ease, background 0.25s ease;
    -webkit-transition: width 0.25s ease, background 0.25s ease;
    -moz-transition: width 0.25s ease, background 0.25s ease;
    -ms-transition: width 0.25s ease, background 0.25s ease;
    /* width: 270px; */
    height: 80px;
    /* box-shadow: 0 -12px 10px 0 rgb(127 143 164 / 36%); */
}

.navbar.default-layout .navbar-brand-wrapper .navbar-brand {
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 48px;
    margin-right: 0px;
    padding: 0.25rem 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.navbar.default-layout .navbar-brand-wrapper .navbar-brand:active,
.navbar.default-layout .navbar-brand-wrapper .navbar-brand:focus,
.navbar.default-layout .navbar-brand-wrapper .navbar-brand:hover {
    color: #424546;
}

.navbar.default-layout .navbar-brand-wrapper .navbar-brand img {
    width: 180px;
    max-width: 100%;
    margin: auto;
    vertical-align: middle;
    padding: 5px 0;
}

.navbar.default-layout .navbar-brand-wrapper .brand-logo-mini img {
    width: 40px;
    max-width: 100%;
    margin: auto;
}

.navbar.default-layout .navbar-menu-wrapper {
    transition: width 0.25s ease;
    -webkit-transition: width 0.25s ease;
    -moz-transition: width 0.25s ease;
    -ms-transition: width 0.25s ease;
    color: #001737;
    padding-left: 15px;
    padding-right: 30px;
    /* width: calc(100% - 270px); */
    height: 80px;
    -webkit-box-shadow: 10px 4px 16px -3px rgba(167, 175, 183, 0.33);
    box-shadow: 10px 4px 16px 0 rgba(167, 175, 183, 0.33);
}

@media (max-width: 991px) {
    .navbar.default-layout .navbar-menu-wrapper {
         width: auto !important;
        padding-left: 0;
        padding-right: 15px;
        box-shadow: none;
        height: 63px;
    }
}

.navbar.default-layout .navbar-menu-wrapper .navbar-toggler {
    border: 0;
    color: inherit;
}

/* @media (max-width: 991px) {
    .navbar.default-layout .navbar-menu-wrapper .navbar-toggler:not(.navbar-toggler-right) {
        display: none;
    }
} */

.navbar.default-layout .navbar-menu-wrapper .search-form {
    width: 35%;
    margin-right: 30px;
}

.hamburger{
    padding-left: 15px !important;
    margin:0px;
}
.navbar.default-layout .navbar-menu-wrapper .search-form .form-group {
    margin-bottom: 0;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item {
    margin-left: 1rem;
}

@media (max-width: 992px) {
    .navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item {
        margin-left: 10px;
        margin-right: 0px;
    }
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {
    color: inherit;
    font-size: 15px;
    vertical-align: middle;
    color: #645F5E;
}

@media (max-width: 767px) {
    .navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link i {
    font-size: 1.25rem;
    vertical-align: middle;
    margin-right: 0;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown {
    margin-left: 35px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown:before {
    position: relative;
    top: 2px;
    font-size: 20px;
    color: grey;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu {
    min-width: 250px;
    margin-top: 9px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu .dropdown-header {
    padding: 20px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu .dropdown-item {
    padding: 10px 15px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-toggle:after {
    position: relative;
    top: 50%;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu {
    width: 170px;
    left: -15px !important;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu .dropdown-item {
    padding-left: 22px;
    padding-right: 12px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu .dropdown-item .flag-icon-holder {
    margin-right: 15px;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .flag-icon-holder {
    height: 25px;
    width: 25px;
    border-radius: 100%;
    overflow: hidden;
}

.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .flag-icon-holder i {
    font-size: 25px;
}

@media (min-width: 991px) {
    .navbar.default-layout .navbar-menu-wrapper .navbar-nav.navbar-nav-right {
        margin-left: auto;
    }
    .rtl .navbar.default-layout .navbar-menu-wrapper .navbar-nav.navbar-nav-right {
        margin-left: 0;
        margin-right: auto;
    }
    #Profile{
        height: auto !important;
    }
}

@media (max-width: 990px) {
    .navbar.default-layout {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
    }
    .navbar.default-layout .navbar-brand-wrapper {
        /* width: 70px; */
        background: #fff;
        box-shadow: none;
        border: none;
        height: 63px;
    }
    .navbar.default-layout .navbar-brand-wrapper .brand-logo {
        display: none;
    }
    .navbar.default-layout .navbar-brand-wrapper .brand-logo-mini {
        display: inline-block;
        margin-right: 0;
    }
    .navbar-collapse {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-top: 0.5rem;
    }
}
/* Sidebar */

.rounded-border {
    border-radius: 20px !important;
}

.card {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px 0px;
    border-radius: 0px;
}

.card .card-title {
    color: #212529;
}

.card .card-header {
    background: #fff;
}

.page-body-wrapper {
    min-height: calc(100vh - 63px);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    padding-left: 0;
    padding-right: 0;
}

.page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
}

.main-panel {
    -webkit-transition: width 0.25s ease, margin 0.25s ease;
    transition: width 0.25s ease, margin 0.25s ease;
    width: calc(100% - 270px);
    min-height: calc(100vh - 63px);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-left: 270px;
}

@media (max-width: 991px) {
    .main-panel {
        margin-left: 0;
        width: 100%;
    }
}

.content-wrapper {
    background: #fafafa;
    padding: 2.5rem 1.7rem;
    width: 100%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.container-scroller {
    overflow: hidden;
}

.page-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    /* padding-bottom: 15px; */
    /* margin-bottom: 15px; */
}

@media (max-width: 992px) {
    .page-header {
        display: inline-block;
    }
}

.page-title {
    margin-top: 0;
    /* margin-bottom: 2px; */
}

@media (max-width: 992px) {
    .page-title {
        margin-bottom: 15px;
    }
}

.quick-links {
    list-style: none;
    margin-bottom: 0;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 4px;
    padding-left: 0;
}

@media (min-width: 992px) {
    .quick-links {
        padding-left: 10px;
    }
}

.quick-links li {
    margin-right: 10px;
    border-right: 1px solid #212529;
    line-height: 1;
}

.quick-links li a {
    display: inline-block;
    color: #212529;
    text-decoration: none;
    padding-right: 10px;
}

.quick-links li:last-child {
    margin-right: 0;
    border-right: none;
}

.quick-links li:last-child a {
    padding-right: 0;
}

.page-title-header {
    /* margin-bottom: 20px; */
}

.page-header-toolbar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
}

@media (max-width: 992px) {
    .page-header-toolbar {
        display: inline-block;
    }
    .page-header-toolbar .toolbar-item {
        margin-top: 20px;
    }
}

.page-header-toolbar .btn-group,
.page-header-toolbar .btn {
    border: none;
}

.page-header-toolbar .btn-group i,
.page-header-toolbar .btn i {
    font-size: 1.24rem;
    color: #2196f3;
}

.page-header-toolbar .btn-group.dropdown-toggle:after,
.page-header-toolbar .btn.dropdown-toggle:after {
    color: #2196f3;
}

.filter-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-left: 15px;
}
/**login**/


.login-content {
    max-width: 620px;
    margin: auto;
    padding: 2rem 3rem;
    width: 100%;
    background: #fff;
    text-align: left;
    border-radius: 0px;
}

.login-content h3 {
    font-size: 24px;
    margin: 25px 0;
    font-weight: 600;
}

label {
    text-align: left;
    display: block;
    font-size: 17px;
    font-weight: 700;
}

.login-content .form-control {
    background: transparent;
    border: none;
    border-bottom: 1px solid #1564B7;
    border-radius: 0;
    padding-left: 0;
}

.login-content .form-group.row {
    text-align: left;
    margin: 25px 0;
}

.login-content .form-group.row label {
    display: inline-block;
    padding: 0 0 0 5px;
    vertical-align: middle;
    font-size: 15px;
    font-weight: normal;
}

.login-content .form-group.row input[type=checkbox] {
    width: 18px;
    height: 18px;
}

.forget-link {
    text-align: right;
}

.forget-link a {
    color: #4F84F4;
    font-size: 15px;
    font-family: Frutiger45-Light;
}

.login-content .form-btn {
    text-align: right;
    margin: 30px 0 0;
}

.login-content .btn {
    background: #0f6aa5;
    border: 1px solid #0f6aa5;
    min-width: 100px;
    font-size: 18px;
    border-radius: 0;
}

.login-content .btn:hover {
    background: #054772;
}

.login-content .btn-back {
    background: #ccc;
    border: 1px solid #ccc;
}

.login-content .btn-back:hover {
    background: #a6a4a4;
}

.login-content .form-btn .btn {
    margin: 0 0 0 15px;
}

.login-bg p {
    font-size: 17px;
    padding: 5px 0 0;
    margin: 0;
    text-align: center;
    font-family: Frutiger45-Light;
    color: #747474;
    line-height: 1.4;
}
/**header**/

.inner-heading {
    border-bottom: 1px solid #CCCCCC;
}

.inner-heading h2 {
    font-size: 20px;
    font-weight: 600;
    color: #323232;
    margin: 0 0 8px;
}

.inner-heading p {
    font-size: 16px;
    font-weight: 700;
    color: #323232;
    text-align: right;
    margin: 0 0 5px;
}

.header-bg {
    height: 82px;
}

.header-bg h1 {
    font-size: 24px;
    color: #323232;
    text-align: center;
    margin: 0;
    padding: 8px 0 8px 15px;
    font-weight: 600;
}

.author-name span {
    font-size: 16px;
    font-weight: 700;
    padding: 13px 0;
    display: block;
    color: #000;
}

.inner-contnet {
    background: #F7F7F7;
    padding: 30px 0;
}

.row-gettor {
    margin-right: -1px;
    margin-left: -1px;
}

.col-gettor {
    padding-left: 1px;
    padding-right: 1px;
}

.search-heading {
    padding-bottom: 15px;
}

.search-heading .btn {
    background: #EEEEEE;
    border-color: #CCCCCC;
    color: #323232;
    font-size: 16px;
    font-weight: 600;
    min-width: 100px;
    margin: 0 0 0 20px;
     /* width: 29% ; */
}

/* .ww{
    width:auto !important;
} */
.advanceBox{
    padding: 0px 20px;
}
.search-heading .btn:hover {
    background: #cbcbcb;
}

.search-heading .form-control {
    font-size: 16px;
    font-weight: 400;
}

.search-box {
    position: relative;
    width: 65%;
}
.search-button:hover {
  border: 1px solid #ccc !important;
  color: black !important;

}
.searchBorder:hover {
  border: 1px solid #ff585d !important;

}

.search-box img {
    position: absolute;
    right: 15px;
    top: 9px;
    width: 19px;
}

.adv-search {
    font-size: 16px;
    font-weight: 600;
    color: #1564B7;
    text-decoration: none;
    padding: 8px 0 0;
    cursor: pointer;
    margin-right: 40px;
}
.adv-search:hover {
    text-decoration: underline;
    color: #1564B7;
    outline: none;
    cursor: pointer;

}
.adv-search i {
    padding: 0 0 0 5px;
    color: #15647b;
    cursor: pointer;
}

.back-to-home {
    font-size: 16px;
    color: #007952;
}

.back-to-home:hover {
    color: #007952;
    text-decoration: none;
}

.back-to-home i {
    padding: 0 5px 0 0;
    font-weight: normal;
    font-size: 20px;
    vertical-align: middle;
}

.user-heading {
    background: #4B5155;
    padding: 10px 20px;
}

.user-heading h3 {
    color: #fff;
    font-size: 20px;
    text-transform: uppercase;
    margin: 0;
    padding: 4px 0 0;
    margin: -5px 0 0 0;
}

.user-heading h3 img {
    padding: 0 15px 0 0;
    max-width: 45px;
    margin: -5px 0 0 0;
}

.user-heading h3 span {
    padding: 6px 0 0;
    display: inline-block;
}

.add-user {
    font-size: 16px;
    color: #fff !important;
    padding: 3px 0px 0 0px;
    display: block;
}

.add-user:hover {
    color: #fff;
}

.add-user img {
    padding: 0 10px 0 0px;
    vertical-align: middle;
    display: inline-block;
    margin: -1px 0 0;
}

.form-btn .btn {
    font-size: 16px;
    margin: 0 0 0 20px;
    min-height: 38px;
}

.btn-link {
    color: #323232;
}

.btn-dark {
    border-radius: 100px;
    padding: .375rem 20px;
}

.search-user {
    padding: 20px 30px;
    background: #fff;
    border: 1px solid #CCCCCC;
    margin: 20px 0;
}

.search-user h4 {
    font-size: 16px;
    color: #323232;
    font-weight: 700;
    background: #fff;
    padding: 15px 20px;
    margin: 0 0 3px;
    box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.07), 0px 4px 8px rgba(48, 49, 51, 0.15);
}

.search-user form {
    background: #F6F8FA;
    padding: 20px;
    position: relative;
    float: left;
    width: 100%;
}

form label {
    font-size: 14px !important;
    color: #808080;
    font-weight: 600;
}

.search-user form ::-webkit-input-placeholder {
    /* Edge */
    color: #323232;
}

.search-user form :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #323232;
}

.search-user form ::placeholder {
    color: #323232;
}

.search-user form .form-group {
    margin-bottom: 20px;
    position: relative;
}

.search-user form .form-btn.pos-ablt {
    /* position: absolute;
    right: 23px;
    bottom: 39px; */
    float: right;
}

.search-user form .form-btn .btn-dark {
    border-radius: 5px;
    background: #B4BCC7;
    color: #fff;
    border: none;
}

.search-user form .form-btn .btn-dark:hover {
    background: #8f949b;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
 border-color: #CED6DD !important
}

/* .search-user form .form-group img {
    position: absolute;
    right: 15px;
    top: 36px;
} */

table.dataTable.hover tbody tr:hover,
table.dataTable.display tbody tr:hover {
    background-color: #fff;
}

table.dataTable tbody td {
    padding: 15px 10px 15px 20px;
}

table.dataTable thead th {
    padding: 10px 10px 15px 20px;
}

table.dataTable thead th img {
    vertical-align: middle;
    display: inline-block;
    margin: -3px 0 0 5px;
}

table.dataTable tbody td:last-child {
    text-align: center;
}

table.dataTable tbody td:last-child img {
    width: 20px;
    margin: 0 10px 0 10px;
}

table.dataTable.display tbody td {
    font-size: 15px;
    color: #323232;
    font-weight: 400;
}

table.dataTable.display tbody td:first-child a {
    color: #1564B7;
}

table.dataTable.display tbody tr.odd>.sorting_1,
table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {
    background-color: #fff;
}

table.dataTable.stripe tbody tr.odd,
table.dataTable.display tbody tr.odd {
    background-color: #fff;
}

table.dataTable thead th:first-child(),
table.dataTable tbody td:first-child {
    min-width: 200px;
}

table.dataTable thead th:nth-child(2),
table.dataTable tbody td:nth-child(2) {
    min-width: 100px;
}

table.dataTable thead th:last-child {
    text-align: left;
}

table.dataTable thead th,
table.dataTable thead td {
    border-bottom: 2px solid #007952;
}

table.dataTable.no-footer {
    border-bottom: none !important;
}

.user-heading.user-bx {
    background: #007952;
}

.custome-box.checkbox {
    width: 100%;
    margin: 5px auto;
    position: relative;
    display: block;
}

.custome-box label {
    position: relative;
    min-height: 34px;
    display: block;
    padding-left: 40px;
    margin-bottom: 0;
    font-weight: normal;
    cursor: pointer;
}

.custome-box label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    margin: -4px 0 0;
    width: 30px;
    height: 30px;
    transition: transform 0.28s ease;
    border-radius: 3px;
    border: 2px solid #ccc;
}

.custome-box label:after {
    content: '';
    display: block;
    width: 20px;
    height: 8px;
    border-bottom: 2px solid #000;
    border-left: 2px solid #000;
    transform: rotate(-45deg) scale(0);
    transition: transform ease 0.25s;
    position: absolute;
    top: 6px;
    left: 5px;
}

.custome-box span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.custome-box input[type="checkbox"] {
    width: auto;
    opacity: 0.00000001;
    position: absolute;
    left: 0;
    margin-left: -20px;
}

.custome-box input[type="checkbox"]:checked~label::before {
    border: 2px solid #000;
}

.custome-box input[type="checkbox"]:checked~label:focus+label::before {
    outline: 0;
}

.custome-box input[type="checkbox"]:checked~label::after {
    transform: rotate(-45deg) scale(1);
}

.user-profile .modal-title {
    font-size: 18px;
    text-transform: uppercase;
}

.user-profile .modal-header {
    padding: 2rem 0rem 5px;
    margin: 0 20px;
    border-bottom: 1px solid #007952;
}

.profile-popup-01 {
    text-align: center;
    padding: 50px 10px;
}

.profile-popup-01 p {
    font-size: 18px;
    color: #323232;
}

.profile-popup-01 .form-btn .btn {
    border-radius: 100px;
    min-width: 127px;
    padding: 5px 50px;
}

.sam-table {
    background: #fff;
    padding: 10px 0px;
    margin: 10px 0 0;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current {
    background: #B4BCC7 !important;
    font-size: 14px;
    padding: 2px 9px 3px;
    color: #fff !important;
    border: none;
    border-radius: 5px;
    line-height: 21px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
    background: #323232 !important;
    color: #fff !important;
    border: none;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
    color: #323232 !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
    border-radius: 0px;
    padding: 0 10px 0 10px;
    margin-left: 0;
    background: #fff !important;
    color: #323232;
}

table.dataTable.display tbody tr.even>.sorting_1,
table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {
    background: #fff;
}

.dataTables_wrapper .dataTables_paginate {
    float: none;
    text-align: right;
    padding-top: 1.5rem;
}

table.dataTable thead th {
    font-size: 16px;
    font-weight: 700;
}

.author-name .nav-link {
    padding: 0;
}

.author-name .dropdown-menu {
    margin: .9rem 0 0;
    min-width: 11rem;
    border-radius: 0;
}

.author-name .dropdown-menu a.dropdown-item {
    font-size: 16px;
    color: #000;
}

.author-name .dropdown-menu i {
    padding: 0 10px 0 0;
    font-size: 23px;
    vertical-align: middle;
    display: inline-block;
    margin: -5px 0 0;
}

.back-to-home img {
    width: 21px;
    margin: -3px 5px 0 0px;
    display: inline-block;
}

.modal-content {
    min-height: 340px;
}

.sam-table {
    position: relative;
}

.total-record {
    width: 7%;
    position: absolute;
    bottom: 5px;
    background: #F6F8FA;
    border: none;
}


 .master-data .nav-tabs {
    border-bottom: none;
}

.master-data .nav-tabs li a {
    background: #679BD3;
    padding: 20px 15px;
    text-transform: uppercase;
    border-radius: 0px;
    color: #fff;
    font-size: 14px;
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: center;
    border-top: 2px solid #CED6DD;
    height: 100%;
   /* // cursor: pointer !important; */
}

.dbtabs  .master-data .nav-tabs li a span {
    width: inherit;
    float: none;
    font-size: 23px;
    font-weight: 700;
    padding: 5px 0 0;
    line-height: 1;
}


.dbtabs  .master-data .nav-tabs li a h4 {
    width: inherit;
    float: none;
    padding-top: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    text-transform: capitalize;
    text-align: center;
    margin: 0;
}

.dbtabs .master-data .nav-tabs li {
    margin: 0 0px 0px 0;
    display: inline-block;
    /* //cursor: pointer !important; */
}
.disabled-link {
    pointer-events: none !important;
  cursor: no-drop !important;
}

.dbtabs  .master-data .nav-tabs li:last-child a h4 {
    padding-top: 10px;
}

.dbtabs .master-data .nav-tabs li:nth-child(4) a h4 {
    padding-top: 10px;
}

.dbtabs .master-data .nav-tabs li:nth-child(3) a h4 {
    padding-top: 10px;
}

.dbtabs .master-data .nav-tabs li:nth-child(5) a h4 {
    padding-top: 10px;
}

.master-data .nav-tabs li:nth-child(6) a h4 {
    padding-top: 10px;
}

.dbtabs .master-data .nav-tabs li a i {
    font-size: 20px;
    display: block;
    text-align: center;
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1px;
}

.dbtabs .master-data .nav-tabs li a img {
    max-width: 22px;
    margin: -5px 10px 0 0;
    width: 24px;
    float: left;
}

.dbtabs .master-data .nav-tabs li:last-child {
    margin: 0;
}

.dbtabs .master-data .nav-tabs .nav-item.show .nav-link,
.dbtabs .master-data .nav-tabs .nav-link.active {
    color: #fff;
    background-color: #1F5186 !important;
    border-color: #1F5186;
    border-top: 4px solid #ED6C00;
}

.dbtabs .master-data .nav-tabs .nav-link.active i {
    display: block;
}

.tabs-row {
    padding: 20px 0px 0;
}

.tabs-row .col-lg-2 {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
}

.tabs-row.tabs-06 .col-lg-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
}
.tabs-row.tabs-06 .col-lg-2 {
    max-width: 14.28%;
}

.search-heading h3 {
    font-size: 24px;
    color: #323232;
    font-weight: 700;
    text-transform: uppercase;
    border-left: 3px solid #ED6C00;
    padding: 0 0 0 5px;
    line-height: 25px;
}

.text-color {
    color: #323232;
    padding: 10px 0;
    display: block;
    text-align: right;
}

.form-btn.text-right {
    border-top: 1px solid #CCCCCC;
    padding: 20px 0 0px;
    margin-top: 10px;
}

.modal-dialog {
    max-width: 550px;
}

.dropd-icon img {
    padding: 0 10px 0 0;
    width: 30px;
    margin: -5px 0 0;
}

.reports-bx {
    background: #ccc;
    padding: 40px 20px;
    text-align: center;
}

.reports-bx figure {
    width: 75px;
    height: 75px;
    background: #009FDD;
    border-radius: 100px;
    text-align: center;
    padding: 15px 10px 15px 15px;
    display: inline-block;
}

.yellow-bx figure {
    background: #DE6C11;
}

.green-bx figure {
    background: #00624C;
}

.gray-bx figure {
    background: #333B41;
}

.reports-bx figure img {
    max-width: 45px;
}

.blue-bx {
    background: #01ADEF;
}

.yellow-bx {
    background: #F48126;
}

.green-bx {
    background: #028164;
}

.gray-bx {
    background: #4B5155;
}

.reports-bg {
    margin-top: 40px;
    padding-left: 4.4rem;
    padding-right: 4.4rem;
}

.reports-bx h5 {
    font-size: 18px;
    color: #fff;
    text-transform: uppercase;
    min-height: 75px;
    position: relative;
}

.reports-bx h5::before {
    content: "";
    height: 2px;
    background: #fff;
    position: absolute;
    left: 0;
    margin: 0;
    bottom: 12px;
    width: 60%;
    margin: auto;
    right: 0;
}

.reports-bx h3 {
    font-size: 80px;
    color: #fff;
    margin-bottom: 10px;
}

.reports-bx h3 small {
    display: block;
    font-size: 18px;
    padding-bottom: 10px;
}

.btn-details {
    border: 1px solid #fff;
    border-radius: 100px;
    padding: 8px 20px;
    font-size: 16px;
    color: #fff;
}

.btn-details:hover {
    background: #fff;
}

.report-form .form-group {
    position: relative;
}

.report-form .form-group img {
    position: absolute;
    right: 30px;
    top: 6px;
}

.report-form .text-center {
    border: none;
    margin-top: 15px;
}

.report-form .sam-table {
    margin: 0;
}

.total-records {
    margin: 20px 0;
    font-size: 16px;
}

.user-heading.yellow-bx .form-group {
    margin-bottom: 0;
}

.user-heading.yellow-bx .form-group label {
    font-size: 16px;
    color: #fff;
    text-align: right;
}

.user-heading.yellow-bx h3 {
    padding: 8px 0 0;
}

.dark-gray {
    background-color: #323232;
}



.sam-table .float-right img {
    width: 30px;
}

.sam-table .float-right {
    padding: 10px 0 0;
}

.user-heading.yellow-bx .form-group select {
    background-color: #fff;
}

.total-records strong {
    color: #007952;
}

.max-value {
    max-height: 34px;
}

.user-profile {
    padding: 25px 18px 5px 18px;
    /* margin-top: 20px; */
}

.user-profile figure {
    text-align: center;
}

.user-profile h5 {
    margin: 0;
    padding: 2px 0 0;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
}



.breadcrum-menu {
    float: right;
}

.breadcrumb {
    background: transparent;
    padding: 0;
    margin: 0;
}

.breadcrumb li {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
}

.breadcrumb li a {
    color: #323232;
    font-weight: 700;
}

.request-form form {
    background: transparent;
    padding: 0 10px;
}

.user-profile span {
    font-size: 13px;
    color: #fff;
    font-weight: 400;
}

.no-approve label {
    font-size: 13px !important;
    font-weight: 600;
    color: #323232;
    margin: 10px 0 0;
}

.request-form figure {
    margin: 0;
}

.request-form span {
    font-size: 10px;
    font-weight: 400;
    color: #808080;
    text-align: left;
    display: block;
    padding: 5px 0 0;
}

arrow.pn

.file-Upload label {
    padding: 5px 0 0;
    display: inline-block;
}

.upload-btn {
    background: #EEEEEE;
    border: 1px solid #CCCCCC;
    font-size: 16px;
    font-weight: 600;
    padding: .375rem 20px;
    margin: 0 0 0 5px;
    width: auto;
}

.doc-label {
    list-style: none;
    padding: 0;
    margin: 0;
}

.doc-label li {
    display: inline-block;
}

.doc-label li a {
    background: #F7F7F7;
    padding: 6px 8px;
    font-size: 14px;
    font-weight: 600;
    margin: 3px 0px 12px 5px;
    display: block;
    border-radius: 5px;
}

.doc-label li a img {
    padding: 7px 0 0 10px;
    float: right;
}

.request-form .form-btn {
    text-align: right;
    border-top: 1px solid #ccc;
    padding: 20px 0;
    margin: 20px 0 0;
}

.request-form .form-btn .btn {
    border-radius: 100px;
    padding: .375rem 25px;
}

.search-bx h5 {
    font-size: 18px;
    text-transform: uppercase;
    color: #fff;
    font-weight: 600;
}

.search-bx .modal-header {
    background: #679BD3;
}

.search-bx .modal-content {
    border: none;
    border-radius: 5px;
}

.search-bx .modal-header span {
    color: #fff;
    opacity: 1;
    font-size: 30px;
    font-weight: normal;
    margin: -3px 0 0 0;
    display: block;
}

.search-bx .close {
    opacity: 1;
}

.approval-popup {
    text-align: center;
    padding: 35px 55px;
    font-weight: 400;
}

.approval-popup p {
    font-size: 15px;
    color: #323232;
}

.search-bx .modal-footer .btn {
    border-radius: 100px;
    padding: .375rem 25px;
}

.app-bx .search-heading h3 {
    text-transform: capitalize;
}

.app-bx .rq_inf_box span {
    text-align: left;
    font-size: 16px !important;
    color: #808080;
    font-weight: 600;
    padding-bottom: 5px;
}

.app-bx .rq_inf_box p {
    text-align: left;
    font-size: 14px !important;
    color: #323232;
    font-weight: 600;
}

.pen-appoval table.dataTable.display thead th:nth-child(1),
.pen-appoval table.dataTable.display tbody td:nth-child(1) {
    min-width: 220px;
}

.pen-appoval table.dataTable.display thead th:nth-child(3),
.pen-appoval table.dataTable.display tbody td:nth-child(3) {
    min-width: 120px;
}

.pen-appoval table.dataTable.display thead th,
.pen-appoval table.dataTable.display tbody td {
    text-align: left;
}

.pen-appoval table.dataTable.display tbody td:last-child {
    text-align: left;
}

.doc-label.lw-25 li {
    width: 25%;
}

.tabs-05 .col-xl-2 {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
}

.form-btn.text-rht {
    text-align: right;
}

.error-msg .form-control {
    border: 1px solid #f03004;
}

.error-msg span {
    font-size: 12px;
    color: #f03004;
    text-align: left;
}

.footer-bg {
    text-align: center;
    padding: 20px 0;
}

.footer-bg ul li {
    display: inline-block;
    font-size: 14px;
}

.footer-bg ul li a {
    border-right: 1px solid #323232;
    padding: 0 12px 0 8px;
    line-height: 15px;
    display: block;
    font-size: 14px;
    color: #323232;
}

.footer-bg ul li:last-child {
    padding: 0 0 0 8px;
}

@media (min-width: 1450px) {
    .dbtabs  .master-data .nav-tabs li a h4 {
        font-size: 16px;
    }
    .master-data .nav-tabs li a span {
        font-size: 30px;
    }
    /* .master-data .nav-tabs li:nth-child(6) a h4 {
        padding: 0px 0px 0 45px;
    } */
    /* .master-data .tabs-06 .nav-tabs li:nth-child(4) a h4 {
        padding: 10px 0px 0 10px;
    } */
    .search-box {
        position: relative;
        width: 80%;
    }
    .search-heading .btn {
        width: auto;
    }
    .upload-btn {
        width: 55%;
    }
    form label {
        font-size: 16px !important;
    }
    /* .search-user form .form-group img {
        top: 40px;
    } */
}

@media (max-width: 1200px) {
    .tabs-05 .col-lg-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .breadcrumb li {
        font-size: 15px;
    }
    .form-btn .btn {
        font-size: 15px;
        margin: 0 0 0 3px;
    }
    .request-form .form-btn .btn {
        padding: .375rem 15px;
    }
    .search-user form .form-btn.pos-ablt {
        position: relative;
        right: 0;
        bottom: 0;
        text-align: right
    }
}

@media (max-width: 990px) {
    .user-profile .col-6.pr-0 {
        -ms-flex: 0 0 10% !important;
        flex: 0 0 10% !important;
        max-width: 10% !important;
    }
    .sam-table > table {
        display: block;
        width: 100%;
        overflow-x: auto;
    }
    .tabs-row .col-lg-2 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .search-user .col-lg-3 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .out-form .col-lg-2 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .out-form .col-lg-4 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .search-user form .form-btn {
        position: relative !important;
        right: 0 !important;
        bottom: 0 !important;
    }
    .search-box {
        position: relative;
        width: 60%;
    }
    .out-form .form-check.pt-4.mt-3 {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
    .request-form .form-btn .btn {
        width: 100%;
        margin-bottom: 15px;
    }
    .search-heading .search-button {
    min-width: 300px;
}
}

@media (max-width: 992px) {
    .sam-table > table {
        display: block;
        width: 100%;   
        overflow-x: auto;
    }
    .header-bg h1 {
        font-size: 16px;
        padding-right: 65px;
    }
    .author-name,
    .form-btn {
        text-align: center;
        float: none !important;
    }
    .header-bg {
        height: 70px;
        box-shadow: 10px 4px 16px 0 rgba(167, 175, 183, 0.33);
    }
    .user-heading h3 {
        font-size: 20px;
    }
    .search-user form .form-group {
        margin: 0 0 20px;
    }
    .check-box .col-form-label {
        flex: 0 0 26%;
        max-width: 26%;
        text-align: left;
    }
    .reports-bx {
        margin-bottom: 30px;
    }
    .col-form-label {
        text-align: left !important;
    }
    .data-cnt .col-sm-3 {
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }
    .data-cnt .pl-0 {
        padding-left: 15px!important;
    }
    .search-user form {
        padding: 30px 5px;
    }
    .sam-table {
        padding: 5px 15px;
    }
    .mob-width {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }
    .tabs-row .col-lg-2 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .tabs-row.tabs-06 .col-lg-2 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .search-user form .form-btn {
        position: relative !important;
        right: 0 !important;
        bottom: 0 !important;
    }
    .search-heading h3 {
        margin-bottom: 20px;
    }
    .total-record {
        width: 15%;
    }
    .tabs-05 .col-lg-4 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .file-Upload {
        margin-bottom: 20px;
    }
    .doc-label li a {
        margin: 3px 12px 12px 0px;
    }
    .request-form figure {
        display: none;
    }

}

@media (max-width: 768px) {
    table.dataTable.display tbody td {
        min-width: 165px;
    }
    table.dataTable.display tbody td:nth-child(2),
    table.dataTable.display tbody td:nth-child(3) {
        min-width: 200px;
    }
    .footer-bg ul li {
        padding: 0 0 10px;
    }
    .form-btn .btn {
        margin: 0 15px 10px 0;
        width: 100%;
    }
    .master-data .nav-tabs li a {
        padding: 20px 10px;
        font-size: 16px;
        min-width: 300px;
    }
    .master-data .nav-tabs li {
        padding: 0 0 5px;
        width: 100%;
    }
    .text-color {
        text-align: left;
        padding: 10px 0;
    }
    .user-heading.yellow-bx .form-group {
        margin-bottom: 10px;
        margin-top: 15px;
    }
    .reports-bg {
        padding-left: 1rem;
        padding-right: 1rem
    }
    .user-heading h3 {
        font-size: 18px;
    }
    .inner-heading p {
        text-align: left;
    }
    .master-data .nav-tabs li:last-child a h4 {
        padding: 10px 0px 0 25px;
    }
    .master-data .nav-tabs li a h4 {
        padding: 10px 0;
    }
    .user-profile figure {
        text-align: left;
    }
    .user-profile .col-6.pl-0 {
        -ms-flex: 0 0 80%;
        flex: 0 0 80%;
        max-width: 80%;
    }
    .breadcrum-menu {
        float: left;
    }
    .breadcrumb li {
        font-size: 12px;
    }
    .breadcrumb-item+.breadcrumb-item::before {
        height: 9px;
    }
    .inner-heading {
        padding: 0 0 10px;
    }
    .doc-label {
        margin-top: 20px;
    }
    .request-form figure {
        text-align: center;
    }
    .doc-label li {
        width: 100%;
    }
    .request-form form {
        padding: 0px 5px 30px;
    }
    .doc-label li a {
        margin: 3px 0px 12px 0px;
    }
    .search-heading.mp-1 {
        padding-bottom: 0;
    }
    .approval-popup {
        padding: 35px 25px;
    }
    .no-approve label {
        margin: 0 0 5px;
    }
    .pen-appoval table.dataTable.display thead th:nth-child(4),
    .pen-appoval table.dataTable.display tbody td:nth-child(4) {
        min-width: 400px;
    }
    .master-data .nav-tabs li:nth-child(5) a h4 {
        padding: 10px 0px 0 10px;
    }
    .out-form .form-check.pt-4.mt-3 {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
    .navbar.default-layout .navbar-menu-wrapper {
        /* width: calc(100% - 75px) !important; */
    }
    .navbar.default-layout .navbar-menu-wrapper.collapsed {
        /* width: calc(100% - 130px) !important; */
    }
}

@media (max-width: 480px) {
    .search-user {
        padding: 20px 5px;
    }
    .search-box {
        width: 100%;
        margin-bottom: 5px;
        position: relative;
    }
    .search-heading .form-control {
        font-size: 14px;
    }
    .search-heading h3 {
        font-size: 18px;
    }
    .add-user {
        float: none !important;
        padding: 15px 0px 15px 0px;
    }
    .header-bg h1 {
        padding: 0;
        /* font-size: 12px; */
    }
    .check-box {
        margin: 0 !important;
    }
    .check-box label {
        text-align: left;
        width: 50%;
        float: left;
    }
    .check-box .col-sm-4.pl-0 {
        width: 40%;
        float: left;
    }
    .author-name span {
        display: none;
    }
    .form-btn {
        padding: 20px 0;
        text-align: left;
    }
    .check-box .col-form-label {
        flex: 0 0 50%;
        max-width: 50%;
        text-align: left;
    }
    .modal .form-btn {
        text-align: center;
    }
    .mob-width {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
    }
    .total-record {
        width: 25%;
    }
    .navbar.default-layout .navbar-menu-wrapper {
        width: auto
    }
    .user-profile .col-6.pr-0 {
        -ms-flex: 0 0 20% !important;
        flex: 0 0 20% !important;
        max-width: 20% !important;
    }
    .navbar.default-layout .navbar-menu-wrapper {
        width: calc(100% - 100px) !important;
    }
    .navbar.default-layout .navbar-menu-wrapper.collapsed {
        width: calc(100% - 200px) !important;
    }

}

.ms-BasePicker-itemsWrapper{
display:flex !important;
padding: 0px 0 0 !important;
}
button.ms-Button.ms-Button--icon.ms-PickerItem-removeButton{
min-width:0em !important;
}
span.ms-Button-flexContainer{
padding:0px 0 0 !important;
display:flex !important;
color:black;
}


button:focus{
    outline: none !important;
    box-shadow: none !important;
  }

  @media (min-width: 992px) {
    /* .navbar .navbar-brand-wrapper {
        width: 70px;
    }
    .navbar .navbar-menu-wrapper {
        width: calc(100% - 70px);
    } */
}

.navbar.default-layout .navbar-brand-wrapper .brand-logo-mini img {
    width: 50px;
    max-width: 100%;
    margin: auto;
}
#smalllogo {
    display: inline-block;
}
@media (min-width: 992px) {
    .sidebar-icon-only .navbar .navbar-brand-wrapper .brand-logo-mini {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-right: 0px;
    }
    
}

.navbar.default-layout .navbar-brand-wrapper.collapsed {
    width: 70px !important;
  }
  
  .navbar.default-layout .navbar-menu-wrapper.collapsed {
    width: calc(100% - 75px) !important;
  }
  
  .navbar.default-layout .navbar-brand-wrapper.collapsed {
  margin-left: 5px;
  }

  .navbar.default-layout .navbar-brand-wrapper {
  margin-left: 30px;
  }
  
  .navbar.default-layout .navbar-menu-wrapper {
        width: calc(100% - 270px);
        
  }
  .navbar-expand .navbar-toggler {
    display: block !important;
}
.spinner-border {
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
  }
  .thin-spinner {
    border-width: 2px !important; /* Adjust thickness */
  }

  .sidebar li.nav-item a.nav-link{
    height: 55px ;
  }

  .sidebar li.has-submenu > a.nav-link {
    height: 55px;
  }

.submenu-container .nav-link.hieght35,
.sub-submenu-container .nav-link.hieght35 {
    height: 40px !important;
}

li.has-submenu:has(.menu-label:contains("Archive")) .submenu-container .nav-link svg.me-2 {
    display: none;
}

@media screen and (min-device-width: 478px) and (max-device-width: 580px) { 
.navbar.default-layout .navbar-menu-wrapper {
    width: auto; 
     margin-right: 20px;
}


}
@media (max-width: 991px) {
     .onSmallScreen{
         display: none; 
    }
}

@media (min-width: 992px) {
    .d-lg-none {
         display: none !important; 
    }
    .onSmallerOnlyButton {
    position: absolute;
    right: 60px;
}
}

@media (max-width: 190px) {
    .d-lg-none{
        display: none;
    }

}
@media (max-width: 490px) {
    .header-bg h1 {
      display: none;
    }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,mDAAmD;IACnD,2DAA2D;IAC3D,wDAAwD;IACxD,uDAAuD;IACvD,kBAAkB;IAClB,YAAY;IACZ,uDAAuD;AAC3D;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;IACZ,gEAAgE;IAChE,qDAAqD;AACzD;;AAEA;IACI;SACK,sBAAsB;QACvB,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;;;;GAIG;;AAEH;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,kBAAkB;IACtB;AACJ;AACA,YAAY;;AAEZ;IACI,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,uDAAuD;IACvD,+CAA+C;IAC/C,yBAAyB;IACzB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;AACrB;AACA,UAAU;;;AAGV;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;AACpB;AACA,WAAW;;AAEX;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;KACjB,iBAAiB;AACtB;;AAEA;;GAEG;AACH;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;EACE,iCAAiC;EACjC,uBAAuB;;AAEzB;AACA;EACE,oCAAoC;;AAEtC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,eAAe;;AAEnB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kFAAkF;AACtF;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;;mBAEe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;CAEC;AACD;;AAEA;;;;GAIG;;AAEH;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,2BAA2B;IAC3B,kCAAkC;IAClC,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;;CAGC;IACG,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;GACb,mCAAmC;AACtC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC;AACtC;AACA;IACI,+BAA+B;EACjC,0BAA0B;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,oCAAoC;IACpC,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;;;AAIA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;IAGI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;OAEG;IACH;;OAEG;IACH;QACI,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,0BAA0B;IAC9B;IACA;;OAEG;AACP;;AAEA;IACI;QACI,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;IACA,gBAAgB;AACpB;AACA;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;;QAEI,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,qDAAqD;IACzD;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;IACA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,eAAe;QACf,cAAc;IAClB;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI,4BAA4B;QAC5B,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,oCAAoC;IACxC;IACA;QACI,oCAAoC;IACxC;;AAEJ;;AAEA;AACA,uBAAuB;AACvB,2BAA2B;AAC3B;AACA;AACA,wBAAwB;AACxB;AACA;AACA,0BAA0B;AAC1B,uBAAuB;AACvB,WAAW;AACX;;;AAGA;IACI,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE;;;;;OAKG;AACP;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;EACA,gBAAgB;EAChB;;EAEA;EACA,iBAAiB;EACjB;;EAEA;QACM,yBAAyB;;EAE/B;EACA;IACE,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,4BAA4B,EAAE,qBAAqB;EACrD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;AAEF;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;AACA;IACI,WAAW;KACV,kBAAkB;AACvB;;;AAGA;AACA;KACK;SACI,aAAa;IAClB;AACJ;;AAEA;IACI;SACK,wBAAwB;IAC7B;IACA;IACA,kBAAkB;IAClB,WAAW;AACf;AACA;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ;AACA;IACI;MACE,aAAa;IACf;AACJ","sourcesContent":["\r\n.btn-primary {\r\n    background-color: #1F5186;\r\n    border-color: #1F5186;\r\n}\r\n\r\n.btn-dark:hover {\r\n    background: #007952;\r\n    border-color: #007952;\r\n}\r\n\r\n.navbar.default-layout {\r\n    font-family: \"roboto\", sans-serif;\r\n    background: #fff;\r\n    transition: background 0.25s ease;\r\n    -webkit-transition: background 0.25s ease;\r\n    -moz-transition: background 0.25s ease;\r\n    -ms-transition: background 0.25s ease;\r\n    box-shadow: 0 0 10px 0 rgb(255 255 255);\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper {\r\n    transition: width 0.25s ease, background 0.25s ease;\r\n    -webkit-transition: width 0.25s ease, background 0.25s ease;\r\n    -moz-transition: width 0.25s ease, background 0.25s ease;\r\n    -ms-transition: width 0.25s ease, background 0.25s ease;\r\n    /* width: 270px; */\r\n    height: 80px;\r\n    /* box-shadow: 0 -12px 10px 0 rgb(127 143 164 / 36%); */\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper .navbar-brand {\r\n    color: #ffffff;\r\n    font-size: 1.5rem;\r\n    line-height: 48px;\r\n    margin-right: 0px;\r\n    padding: 0.25rem 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper .navbar-brand:active,\r\n.navbar.default-layout .navbar-brand-wrapper .navbar-brand:focus,\r\n.navbar.default-layout .navbar-brand-wrapper .navbar-brand:hover {\r\n    color: #424546;\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper .navbar-brand img {\r\n    width: 180px;\r\n    max-width: 100%;\r\n    margin: auto;\r\n    vertical-align: middle;\r\n    padding: 5px 0;\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper .brand-logo-mini img {\r\n    width: 40px;\r\n    max-width: 100%;\r\n    margin: auto;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper {\r\n    transition: width 0.25s ease;\r\n    -webkit-transition: width 0.25s ease;\r\n    -moz-transition: width 0.25s ease;\r\n    -ms-transition: width 0.25s ease;\r\n    color: #001737;\r\n    padding-left: 15px;\r\n    padding-right: 30px;\r\n    /* width: calc(100% - 270px); */\r\n    height: 80px;\r\n    -webkit-box-shadow: 10px 4px 16px -3px rgba(167, 175, 183, 0.33);\r\n    box-shadow: 10px 4px 16px 0 rgba(167, 175, 183, 0.33);\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .navbar.default-layout .navbar-menu-wrapper {\r\n         width: auto !important;\r\n        padding-left: 0;\r\n        padding-right: 15px;\r\n        box-shadow: none;\r\n        height: 63px;\r\n    }\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-toggler {\r\n    border: 0;\r\n    color: inherit;\r\n}\r\n\r\n/* @media (max-width: 991px) {\r\n    .navbar.default-layout .navbar-menu-wrapper .navbar-toggler:not(.navbar-toggler-right) {\r\n        display: none;\r\n    }\r\n} */\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .search-form {\r\n    width: 35%;\r\n    margin-right: 30px;\r\n}\r\n\r\n.hamburger{\r\n    padding-left: 15px !important;\r\n    margin:0px;\r\n}\r\n.navbar.default-layout .navbar-menu-wrapper .search-form .form-group {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav {\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item {\r\n    margin-left: 1rem;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item {\r\n        margin-left: 10px;\r\n        margin-right: 0px;\r\n    }\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {\r\n    color: inherit;\r\n    font-size: 15px;\r\n    vertical-align: middle;\r\n    color: #645F5E;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link {\r\n        margin-left: 0.5rem;\r\n        margin-right: 0.5rem;\r\n    }\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item .nav-link i {\r\n    font-size: 1.25rem;\r\n    vertical-align: middle;\r\n    margin-right: 0;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown {\r\n    margin-left: 35px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown:before {\r\n    position: relative;\r\n    top: 2px;\r\n    font-size: 20px;\r\n    color: grey;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu {\r\n    min-width: 250px;\r\n    margin-top: 9px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu .dropdown-header {\r\n    padding: 20px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-menu .dropdown-item {\r\n    padding: 10px 15px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.user-dropdown .dropdown-toggle:after {\r\n    position: relative;\r\n    top: 50%;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu {\r\n    width: 170px;\r\n    left: -15px !important;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu .dropdown-item {\r\n    padding-left: 22px;\r\n    padding-right: 12px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .dropdown-menu .dropdown-item .flag-icon-holder {\r\n    margin-right: 15px;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .flag-icon-holder {\r\n    height: 25px;\r\n    width: 25px;\r\n    border-radius: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.navbar.default-layout .navbar-menu-wrapper .navbar-nav .nav-item.language-dropdown .flag-icon-holder i {\r\n    font-size: 25px;\r\n}\r\n\r\n@media (min-width: 991px) {\r\n    .navbar.default-layout .navbar-menu-wrapper .navbar-nav.navbar-nav-right {\r\n        margin-left: auto;\r\n    }\r\n    .rtl .navbar.default-layout .navbar-menu-wrapper .navbar-nav.navbar-nav-right {\r\n        margin-left: 0;\r\n        margin-right: auto;\r\n    }\r\n    #Profile{\r\n        height: auto !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 990px) {\r\n    .navbar.default-layout {\r\n        -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n        flex-direction: row;\r\n    }\r\n    .navbar.default-layout .navbar-brand-wrapper {\r\n        /* width: 70px; */\r\n        background: #fff;\r\n        box-shadow: none;\r\n        border: none;\r\n        height: 63px;\r\n    }\r\n    .navbar.default-layout .navbar-brand-wrapper .brand-logo {\r\n        display: none;\r\n    }\r\n    .navbar.default-layout .navbar-brand-wrapper .brand-logo-mini {\r\n        display: inline-block;\r\n        margin-right: 0;\r\n    }\r\n    .navbar-collapse {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        margin-top: 0.5rem;\r\n    }\r\n}\r\n/* Sidebar */\r\n\r\n.rounded-border {\r\n    border-radius: 20px !important;\r\n}\r\n\r\n.card {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px 0px;\r\n    border-radius: 0px;\r\n}\r\n\r\n.card .card-title {\r\n    color: #212529;\r\n}\r\n\r\n.card .card-header {\r\n    background: #fff;\r\n}\r\n\r\n.page-body-wrapper {\r\n    min-height: calc(100vh - 63px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.page-body-wrapper.full-page-wrapper {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n}\r\n\r\n.main-panel {\r\n    -webkit-transition: width 0.25s ease, margin 0.25s ease;\r\n    transition: width 0.25s ease, margin 0.25s ease;\r\n    width: calc(100% - 270px);\r\n    min-height: calc(100vh - 63px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    margin-left: 270px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .main-panel {\r\n        margin-left: 0;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.content-wrapper {\r\n    background: #fafafa;\r\n    padding: 2.5rem 1.7rem;\r\n    width: 100%;\r\n    -webkit-box-flex: 1;\r\n    -ms-flex-positive: 1;\r\n    flex-grow: 1;\r\n}\r\n\r\n.container-scroller {\r\n    overflow: hidden;\r\n}\r\n\r\n.page-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    /* padding-bottom: 15px; */\r\n    /* margin-bottom: 15px; */\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .page-header {\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.page-title {\r\n    margin-top: 0;\r\n    /* margin-bottom: 2px; */\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .page-title {\r\n        margin-bottom: 15px;\r\n    }\r\n}\r\n\r\n.quick-links {\r\n    list-style: none;\r\n    margin-bottom: 0;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    margin-top: 4px;\r\n    padding-left: 0;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .quick-links {\r\n        padding-left: 10px;\r\n    }\r\n}\r\n\r\n.quick-links li {\r\n    margin-right: 10px;\r\n    border-right: 1px solid #212529;\r\n    line-height: 1;\r\n}\r\n\r\n.quick-links li a {\r\n    display: inline-block;\r\n    color: #212529;\r\n    text-decoration: none;\r\n    padding-right: 10px;\r\n}\r\n\r\n.quick-links li:last-child {\r\n    margin-right: 0;\r\n    border-right: none;\r\n}\r\n\r\n.quick-links li:last-child a {\r\n    padding-right: 0;\r\n}\r\n\r\n.page-title-header {\r\n    /* margin-bottom: 20px; */\r\n}\r\n\r\n.page-header-toolbar {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .page-header-toolbar {\r\n        display: inline-block;\r\n    }\r\n    .page-header-toolbar .toolbar-item {\r\n        margin-top: 20px;\r\n    }\r\n}\r\n\r\n.page-header-toolbar .btn-group,\r\n.page-header-toolbar .btn {\r\n    border: none;\r\n}\r\n\r\n.page-header-toolbar .btn-group i,\r\n.page-header-toolbar .btn i {\r\n    font-size: 1.24rem;\r\n    color: #2196f3;\r\n}\r\n\r\n.page-header-toolbar .btn-group.dropdown-toggle:after,\r\n.page-header-toolbar .btn.dropdown-toggle:after {\r\n    color: #2196f3;\r\n}\r\n\r\n.filter-wrapper {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-left: 15px;\r\n}\r\n/**login**/\r\n\r\n\r\n.login-content {\r\n    max-width: 620px;\r\n    margin: auto;\r\n    padding: 2rem 3rem;\r\n    width: 100%;\r\n    background: #fff;\r\n    text-align: left;\r\n    border-radius: 0px;\r\n}\r\n\r\n.login-content h3 {\r\n    font-size: 24px;\r\n    margin: 25px 0;\r\n    font-weight: 600;\r\n}\r\n\r\nlabel {\r\n    text-align: left;\r\n    display: block;\r\n    font-size: 17px;\r\n    font-weight: 700;\r\n}\r\n\r\n.login-content .form-control {\r\n    background: transparent;\r\n    border: none;\r\n    border-bottom: 1px solid #1564B7;\r\n    border-radius: 0;\r\n    padding-left: 0;\r\n}\r\n\r\n.login-content .form-group.row {\r\n    text-align: left;\r\n    margin: 25px 0;\r\n}\r\n\r\n.login-content .form-group.row label {\r\n    display: inline-block;\r\n    padding: 0 0 0 5px;\r\n    vertical-align: middle;\r\n    font-size: 15px;\r\n    font-weight: normal;\r\n}\r\n\r\n.login-content .form-group.row input[type=checkbox] {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n.forget-link {\r\n    text-align: right;\r\n}\r\n\r\n.forget-link a {\r\n    color: #4F84F4;\r\n    font-size: 15px;\r\n    font-family: Frutiger45-Light;\r\n}\r\n\r\n.login-content .form-btn {\r\n    text-align: right;\r\n    margin: 30px 0 0;\r\n}\r\n\r\n.login-content .btn {\r\n    background: #0f6aa5;\r\n    border: 1px solid #0f6aa5;\r\n    min-width: 100px;\r\n    font-size: 18px;\r\n    border-radius: 0;\r\n}\r\n\r\n.login-content .btn:hover {\r\n    background: #054772;\r\n}\r\n\r\n.login-content .btn-back {\r\n    background: #ccc;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.login-content .btn-back:hover {\r\n    background: #a6a4a4;\r\n}\r\n\r\n.login-content .form-btn .btn {\r\n    margin: 0 0 0 15px;\r\n}\r\n\r\n.login-bg p {\r\n    font-size: 17px;\r\n    padding: 5px 0 0;\r\n    margin: 0;\r\n    text-align: center;\r\n    font-family: Frutiger45-Light;\r\n    color: #747474;\r\n    line-height: 1.4;\r\n}\r\n/**header**/\r\n\r\n.inner-heading {\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n\r\n.inner-heading h2 {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #323232;\r\n    margin: 0 0 8px;\r\n}\r\n\r\n.inner-heading p {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    color: #323232;\r\n    text-align: right;\r\n    margin: 0 0 5px;\r\n}\r\n\r\n.header-bg {\r\n    height: 82px;\r\n}\r\n\r\n.header-bg h1 {\r\n    font-size: 24px;\r\n    color: #323232;\r\n    text-align: center;\r\n    margin: 0;\r\n    padding: 8px 0 8px 15px;\r\n    font-weight: 600;\r\n}\r\n\r\n.author-name span {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    padding: 13px 0;\r\n    display: block;\r\n    color: #000;\r\n}\r\n\r\n.inner-contnet {\r\n    background: #F7F7F7;\r\n    padding: 30px 0;\r\n}\r\n\r\n.row-gettor {\r\n    margin-right: -1px;\r\n    margin-left: -1px;\r\n}\r\n\r\n.col-gettor {\r\n    padding-left: 1px;\r\n    padding-right: 1px;\r\n}\r\n\r\n.search-heading {\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.search-heading .btn {\r\n    background: #EEEEEE;\r\n    border-color: #CCCCCC;\r\n    color: #323232;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    min-width: 100px;\r\n    margin: 0 0 0 20px;\r\n     /* width: 29% ; */\r\n}\r\n\r\n/* .ww{\r\n    width:auto !important;\r\n} */\r\n.advanceBox{\r\n    padding: 0px 20px;\r\n}\r\n.search-heading .btn:hover {\r\n    background: #cbcbcb;\r\n}\r\n\r\n.search-heading .form-control {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n}\r\n\r\n.search-box {\r\n    position: relative;\r\n    width: 65%;\r\n}\r\n.search-button:hover {\r\n  border: 1px solid #ccc !important;\r\n  color: black !important;\r\n\r\n}\r\n.searchBorder:hover {\r\n  border: 1px solid #ff585d !important;\r\n\r\n}\r\n\r\n.search-box img {\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 9px;\r\n    width: 19px;\r\n}\r\n\r\n.adv-search {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #1564B7;\r\n    text-decoration: none;\r\n    padding: 8px 0 0;\r\n    cursor: pointer;\r\n    margin-right: 40px;\r\n}\r\n.adv-search:hover {\r\n    text-decoration: underline;\r\n    color: #1564B7;\r\n    outline: none;\r\n    cursor: pointer;\r\n\r\n}\r\n.adv-search i {\r\n    padding: 0 0 0 5px;\r\n    color: #15647b;\r\n    cursor: pointer;\r\n}\r\n\r\n.back-to-home {\r\n    font-size: 16px;\r\n    color: #007952;\r\n}\r\n\r\n.back-to-home:hover {\r\n    color: #007952;\r\n    text-decoration: none;\r\n}\r\n\r\n.back-to-home i {\r\n    padding: 0 5px 0 0;\r\n    font-weight: normal;\r\n    font-size: 20px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.user-heading {\r\n    background: #4B5155;\r\n    padding: 10px 20px;\r\n}\r\n\r\n.user-heading h3 {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    text-transform: uppercase;\r\n    margin: 0;\r\n    padding: 4px 0 0;\r\n    margin: -5px 0 0 0;\r\n}\r\n\r\n.user-heading h3 img {\r\n    padding: 0 15px 0 0;\r\n    max-width: 45px;\r\n    margin: -5px 0 0 0;\r\n}\r\n\r\n.user-heading h3 span {\r\n    padding: 6px 0 0;\r\n    display: inline-block;\r\n}\r\n\r\n.add-user {\r\n    font-size: 16px;\r\n    color: #fff !important;\r\n    padding: 3px 0px 0 0px;\r\n    display: block;\r\n}\r\n\r\n.add-user:hover {\r\n    color: #fff;\r\n}\r\n\r\n.add-user img {\r\n    padding: 0 10px 0 0px;\r\n    vertical-align: middle;\r\n    display: inline-block;\r\n    margin: -1px 0 0;\r\n}\r\n\r\n.form-btn .btn {\r\n    font-size: 16px;\r\n    margin: 0 0 0 20px;\r\n    min-height: 38px;\r\n}\r\n\r\n.btn-link {\r\n    color: #323232;\r\n}\r\n\r\n.btn-dark {\r\n    border-radius: 100px;\r\n    padding: .375rem 20px;\r\n}\r\n\r\n.search-user {\r\n    padding: 20px 30px;\r\n    background: #fff;\r\n    border: 1px solid #CCCCCC;\r\n    margin: 20px 0;\r\n}\r\n\r\n.search-user h4 {\r\n    font-size: 16px;\r\n    color: #323232;\r\n    font-weight: 700;\r\n    background: #fff;\r\n    padding: 15px 20px;\r\n    margin: 0 0 3px;\r\n    box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.07), 0px 4px 8px rgba(48, 49, 51, 0.15);\r\n}\r\n\r\n.search-user form {\r\n    background: #F6F8FA;\r\n    padding: 20px;\r\n    position: relative;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\nform label {\r\n    font-size: 14px !important;\r\n    color: #808080;\r\n    font-weight: 600;\r\n}\r\n\r\n.search-user form ::-webkit-input-placeholder {\r\n    /* Edge */\r\n    color: #323232;\r\n}\r\n\r\n.search-user form :-ms-input-placeholder {\r\n    /* Internet Explorer 10-11 */\r\n    color: #323232;\r\n}\r\n\r\n.search-user form ::placeholder {\r\n    color: #323232;\r\n}\r\n\r\n.search-user form .form-group {\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n}\r\n\r\n.search-user form .form-btn.pos-ablt {\r\n    /* position: absolute;\r\n    right: 23px;\r\n    bottom: 39px; */\r\n    float: right;\r\n}\r\n\r\n.search-user form .form-btn .btn-dark {\r\n    border-radius: 5px;\r\n    background: #B4BCC7;\r\n    color: #fff;\r\n    border: none;\r\n}\r\n\r\n.search-user form .form-btn .btn-dark:hover {\r\n    background: #8f949b;\r\n}\r\n\r\n.nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n border-color: #CED6DD !important\r\n}\r\n\r\n/* .search-user form .form-group img {\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 36px;\r\n} */\r\n\r\ntable.dataTable.hover tbody tr:hover,\r\ntable.dataTable.display tbody tr:hover {\r\n    background-color: #fff;\r\n}\r\n\r\ntable.dataTable tbody td {\r\n    padding: 15px 10px 15px 20px;\r\n}\r\n\r\ntable.dataTable thead th {\r\n    padding: 10px 10px 15px 20px;\r\n}\r\n\r\ntable.dataTable thead th img {\r\n    vertical-align: middle;\r\n    display: inline-block;\r\n    margin: -3px 0 0 5px;\r\n}\r\n\r\ntable.dataTable tbody td:last-child {\r\n    text-align: center;\r\n}\r\n\r\ntable.dataTable tbody td:last-child img {\r\n    width: 20px;\r\n    margin: 0 10px 0 10px;\r\n}\r\n\r\ntable.dataTable.display tbody td {\r\n    font-size: 15px;\r\n    color: #323232;\r\n    font-weight: 400;\r\n}\r\n\r\ntable.dataTable.display tbody td:first-child a {\r\n    color: #1564B7;\r\n}\r\n\r\ntable.dataTable.display tbody tr.odd>.sorting_1,\r\ntable.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {\r\n    background-color: #fff;\r\n}\r\n\r\ntable.dataTable.stripe tbody tr.odd,\r\ntable.dataTable.display tbody tr.odd {\r\n    background-color: #fff;\r\n}\r\n\r\ntable.dataTable thead th:first-child(),\r\ntable.dataTable tbody td:first-child {\r\n    min-width: 200px;\r\n}\r\n\r\ntable.dataTable thead th:nth-child(2),\r\ntable.dataTable tbody td:nth-child(2) {\r\n    min-width: 100px;\r\n}\r\n\r\ntable.dataTable thead th:last-child {\r\n    text-align: left;\r\n}\r\n\r\ntable.dataTable thead th,\r\ntable.dataTable thead td {\r\n    border-bottom: 2px solid #007952;\r\n}\r\n\r\ntable.dataTable.no-footer {\r\n    border-bottom: none !important;\r\n}\r\n\r\n.user-heading.user-bx {\r\n    background: #007952;\r\n}\r\n\r\n.custome-box.checkbox {\r\n    width: 100%;\r\n    margin: 5px auto;\r\n    position: relative;\r\n    display: block;\r\n}\r\n\r\n.custome-box label {\r\n    position: relative;\r\n    min-height: 34px;\r\n    display: block;\r\n    padding-left: 40px;\r\n    margin-bottom: 0;\r\n    font-weight: normal;\r\n    cursor: pointer;\r\n}\r\n\r\n.custome-box label:before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    margin: -4px 0 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    transition: transform 0.28s ease;\r\n    border-radius: 3px;\r\n    border: 2px solid #ccc;\r\n}\r\n\r\n.custome-box label:after {\r\n    content: '';\r\n    display: block;\r\n    width: 20px;\r\n    height: 8px;\r\n    border-bottom: 2px solid #000;\r\n    border-left: 2px solid #000;\r\n    transform: rotate(-45deg) scale(0);\r\n    transition: transform ease 0.25s;\r\n    position: absolute;\r\n    top: 6px;\r\n    left: 5px;\r\n}\r\n\r\n.custome-box span {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.custome-box input[type=\"checkbox\"] {\r\n    width: auto;\r\n    opacity: 0.00000001;\r\n    position: absolute;\r\n    left: 0;\r\n    margin-left: -20px;\r\n}\r\n\r\n.custome-box input[type=\"checkbox\"]:checked~label::before {\r\n    border: 2px solid #000;\r\n}\r\n\r\n.custome-box input[type=\"checkbox\"]:checked~label:focus+label::before {\r\n    outline: 0;\r\n}\r\n\r\n.custome-box input[type=\"checkbox\"]:checked~label::after {\r\n    transform: rotate(-45deg) scale(1);\r\n}\r\n\r\n.user-profile .modal-title {\r\n    font-size: 18px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.user-profile .modal-header {\r\n    padding: 2rem 0rem 5px;\r\n    margin: 0 20px;\r\n    border-bottom: 1px solid #007952;\r\n}\r\n\r\n.profile-popup-01 {\r\n    text-align: center;\r\n    padding: 50px 10px;\r\n}\r\n\r\n.profile-popup-01 p {\r\n    font-size: 18px;\r\n    color: #323232;\r\n}\r\n\r\n.profile-popup-01 .form-btn .btn {\r\n    border-radius: 100px;\r\n    min-width: 127px;\r\n    padding: 5px 50px;\r\n}\r\n\r\n.sam-table {\r\n    background: #fff;\r\n    padding: 10px 0px;\r\n    margin: 10px 0 0;\r\n}\r\n\r\n.dataTables_wrapper .dataTables_paginate .paginate_button.current {\r\n    background: #B4BCC7 !important;\r\n    font-size: 14px;\r\n    padding: 2px 9px 3px;\r\n    color: #fff !important;\r\n    border: none;\r\n    border-radius: 5px;\r\n    line-height: 21px;\r\n}\r\n\r\n.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {\r\n    background: #323232 !important;\r\n    color: #fff !important;\r\n    border: none;\r\n}\r\n\r\n.dataTables_wrapper .dataTables_paginate .paginate_button:hover {\r\n    color: #323232 !important;\r\n}\r\n\r\n.dataTables_wrapper .dataTables_paginate .paginate_button {\r\n    border-radius: 0px;\r\n    padding: 0 10px 0 10px;\r\n    margin-left: 0;\r\n    background: #fff !important;\r\n    color: #323232;\r\n}\r\n\r\ntable.dataTable.display tbody tr.even>.sorting_1,\r\ntable.dataTable.order-column.stripe tbody tr.even>.sorting_1 {\r\n    background: #fff;\r\n}\r\n\r\n.dataTables_wrapper .dataTables_paginate {\r\n    float: none;\r\n    text-align: right;\r\n    padding-top: 1.5rem;\r\n}\r\n\r\ntable.dataTable thead th {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n\r\n.author-name .nav-link {\r\n    padding: 0;\r\n}\r\n\r\n.author-name .dropdown-menu {\r\n    margin: .9rem 0 0;\r\n    min-width: 11rem;\r\n    border-radius: 0;\r\n}\r\n\r\n.author-name .dropdown-menu a.dropdown-item {\r\n    font-size: 16px;\r\n    color: #000;\r\n}\r\n\r\n.author-name .dropdown-menu i {\r\n    padding: 0 10px 0 0;\r\n    font-size: 23px;\r\n    vertical-align: middle;\r\n    display: inline-block;\r\n    margin: -5px 0 0;\r\n}\r\n\r\n.back-to-home img {\r\n    width: 21px;\r\n    margin: -3px 5px 0 0px;\r\n    display: inline-block;\r\n}\r\n\r\n.modal-content {\r\n    min-height: 340px;\r\n}\r\n\r\n.sam-table {\r\n    position: relative;\r\n}\r\n\r\n.total-record {\r\n    width: 7%;\r\n    position: absolute;\r\n    bottom: 5px;\r\n    background: #F6F8FA;\r\n    border: none;\r\n}\r\n\r\n\r\n .master-data .nav-tabs {\r\n    border-bottom: none;\r\n}\r\n\r\n.master-data .nav-tabs li a {\r\n    background: #679BD3;\r\n    padding: 20px 15px;\r\n    text-transform: uppercase;\r\n    border-radius: 0px;\r\n    color: #fff;\r\n    font-size: 14px;\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    text-align: center;\r\n    border-top: 2px solid #CED6DD;\r\n    height: 100%;\r\n   /* // cursor: pointer !important; */\r\n}\r\n\r\n.dbtabs  .master-data .nav-tabs li a span {\r\n    width: inherit;\r\n    float: none;\r\n    font-size: 23px;\r\n    font-weight: 700;\r\n    padding: 5px 0 0;\r\n    line-height: 1;\r\n}\r\n\r\n\r\n.dbtabs  .master-data .nav-tabs li a h4 {\r\n    width: inherit;\r\n    float: none;\r\n    padding-top: 10px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #fff;\r\n    text-transform: capitalize;\r\n    text-align: center;\r\n    margin: 0;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li {\r\n    margin: 0 0px 0px 0;\r\n    display: inline-block;\r\n    /* //cursor: pointer !important; */\r\n}\r\n.disabled-link {\r\n    pointer-events: none !important;\r\n  cursor: no-drop !important;\r\n}\r\n\r\n.dbtabs  .master-data .nav-tabs li:last-child a h4 {\r\n    padding-top: 10px;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li:nth-child(4) a h4 {\r\n    padding-top: 10px;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li:nth-child(3) a h4 {\r\n    padding-top: 10px;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li:nth-child(5) a h4 {\r\n    padding-top: 10px;\r\n}\r\n\r\n.master-data .nav-tabs li:nth-child(6) a h4 {\r\n    padding-top: 10px;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li a i {\r\n    font-size: 20px;\r\n    display: block;\r\n    text-align: center;\r\n    display: none;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 1px;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li a img {\r\n    max-width: 22px;\r\n    margin: -5px 10px 0 0;\r\n    width: 24px;\r\n    float: left;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs li:last-child {\r\n    margin: 0;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs .nav-item.show .nav-link,\r\n.dbtabs .master-data .nav-tabs .nav-link.active {\r\n    color: #fff;\r\n    background-color: #1F5186 !important;\r\n    border-color: #1F5186;\r\n    border-top: 4px solid #ED6C00;\r\n}\r\n\r\n.dbtabs .master-data .nav-tabs .nav-link.active i {\r\n    display: block;\r\n}\r\n\r\n.tabs-row {\r\n    padding: 20px 0px 0;\r\n}\r\n\r\n.tabs-row .col-lg-2 {\r\n    -ms-flex: 0 0 20%;\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n}\r\n\r\n.tabs-row.tabs-06 .col-lg-2 {\r\n    -ms-flex: 0 0 16.666667%;\r\n    flex: 0 0 16.666667%;\r\n    max-width: 16.666667%;\r\n}\r\n.tabs-row.tabs-06 .col-lg-2 {\r\n    max-width: 14.28%;\r\n}\r\n\r\n.search-heading h3 {\r\n    font-size: 24px;\r\n    color: #323232;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    border-left: 3px solid #ED6C00;\r\n    padding: 0 0 0 5px;\r\n    line-height: 25px;\r\n}\r\n\r\n.text-color {\r\n    color: #323232;\r\n    padding: 10px 0;\r\n    display: block;\r\n    text-align: right;\r\n}\r\n\r\n.form-btn.text-right {\r\n    border-top: 1px solid #CCCCCC;\r\n    padding: 20px 0 0px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.modal-dialog {\r\n    max-width: 550px;\r\n}\r\n\r\n.dropd-icon img {\r\n    padding: 0 10px 0 0;\r\n    width: 30px;\r\n    margin: -5px 0 0;\r\n}\r\n\r\n.reports-bx {\r\n    background: #ccc;\r\n    padding: 40px 20px;\r\n    text-align: center;\r\n}\r\n\r\n.reports-bx figure {\r\n    width: 75px;\r\n    height: 75px;\r\n    background: #009FDD;\r\n    border-radius: 100px;\r\n    text-align: center;\r\n    padding: 15px 10px 15px 15px;\r\n    display: inline-block;\r\n}\r\n\r\n.yellow-bx figure {\r\n    background: #DE6C11;\r\n}\r\n\r\n.green-bx figure {\r\n    background: #00624C;\r\n}\r\n\r\n.gray-bx figure {\r\n    background: #333B41;\r\n}\r\n\r\n.reports-bx figure img {\r\n    max-width: 45px;\r\n}\r\n\r\n.blue-bx {\r\n    background: #01ADEF;\r\n}\r\n\r\n.yellow-bx {\r\n    background: #F48126;\r\n}\r\n\r\n.green-bx {\r\n    background: #028164;\r\n}\r\n\r\n.gray-bx {\r\n    background: #4B5155;\r\n}\r\n\r\n.reports-bg {\r\n    margin-top: 40px;\r\n    padding-left: 4.4rem;\r\n    padding-right: 4.4rem;\r\n}\r\n\r\n.reports-bx h5 {\r\n    font-size: 18px;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    min-height: 75px;\r\n    position: relative;\r\n}\r\n\r\n.reports-bx h5::before {\r\n    content: \"\";\r\n    height: 2px;\r\n    background: #fff;\r\n    position: absolute;\r\n    left: 0;\r\n    margin: 0;\r\n    bottom: 12px;\r\n    width: 60%;\r\n    margin: auto;\r\n    right: 0;\r\n}\r\n\r\n.reports-bx h3 {\r\n    font-size: 80px;\r\n    color: #fff;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.reports-bx h3 small {\r\n    display: block;\r\n    font-size: 18px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.btn-details {\r\n    border: 1px solid #fff;\r\n    border-radius: 100px;\r\n    padding: 8px 20px;\r\n    font-size: 16px;\r\n    color: #fff;\r\n}\r\n\r\n.btn-details:hover {\r\n    background: #fff;\r\n}\r\n\r\n.report-form .form-group {\r\n    position: relative;\r\n}\r\n\r\n.report-form .form-group img {\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 6px;\r\n}\r\n\r\n.report-form .text-center {\r\n    border: none;\r\n    margin-top: 15px;\r\n}\r\n\r\n.report-form .sam-table {\r\n    margin: 0;\r\n}\r\n\r\n.total-records {\r\n    margin: 20px 0;\r\n    font-size: 16px;\r\n}\r\n\r\n.user-heading.yellow-bx .form-group {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.user-heading.yellow-bx .form-group label {\r\n    font-size: 16px;\r\n    color: #fff;\r\n    text-align: right;\r\n}\r\n\r\n.user-heading.yellow-bx h3 {\r\n    padding: 8px 0 0;\r\n}\r\n\r\n.dark-gray {\r\n    background-color: #323232;\r\n}\r\n\r\n\r\n\r\n.sam-table .float-right img {\r\n    width: 30px;\r\n}\r\n\r\n.sam-table .float-right {\r\n    padding: 10px 0 0;\r\n}\r\n\r\n.user-heading.yellow-bx .form-group select {\r\n    background-color: #fff;\r\n}\r\n\r\n.total-records strong {\r\n    color: #007952;\r\n}\r\n\r\n.max-value {\r\n    max-height: 34px;\r\n}\r\n\r\n.user-profile {\r\n    padding: 25px 18px 5px 18px;\r\n    /* margin-top: 20px; */\r\n}\r\n\r\n.user-profile figure {\r\n    text-align: center;\r\n}\r\n\r\n.user-profile h5 {\r\n    margin: 0;\r\n    padding: 2px 0 0;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n\r\n.breadcrum-menu {\r\n    float: right;\r\n}\r\n\r\n.breadcrumb {\r\n    background: transparent;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.breadcrumb li {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: #999999;\r\n}\r\n\r\n.breadcrumb li a {\r\n    color: #323232;\r\n    font-weight: 700;\r\n}\r\n\r\n.request-form form {\r\n    background: transparent;\r\n    padding: 0 10px;\r\n}\r\n\r\n.user-profile span {\r\n    font-size: 13px;\r\n    color: #fff;\r\n    font-weight: 400;\r\n}\r\n\r\n.no-approve label {\r\n    font-size: 13px !important;\r\n    font-weight: 600;\r\n    color: #323232;\r\n    margin: 10px 0 0;\r\n}\r\n\r\n.request-form figure {\r\n    margin: 0;\r\n}\r\n\r\n.request-form span {\r\n    font-size: 10px;\r\n    font-weight: 400;\r\n    color: #808080;\r\n    text-align: left;\r\n    display: block;\r\n    padding: 5px 0 0;\r\n}\r\n\r\narrow.pn\r\n\r\n.file-Upload label {\r\n    padding: 5px 0 0;\r\n    display: inline-block;\r\n}\r\n\r\n.upload-btn {\r\n    background: #EEEEEE;\r\n    border: 1px solid #CCCCCC;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    padding: .375rem 20px;\r\n    margin: 0 0 0 5px;\r\n    width: auto;\r\n}\r\n\r\n.doc-label {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.doc-label li {\r\n    display: inline-block;\r\n}\r\n\r\n.doc-label li a {\r\n    background: #F7F7F7;\r\n    padding: 6px 8px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin: 3px 0px 12px 5px;\r\n    display: block;\r\n    border-radius: 5px;\r\n}\r\n\r\n.doc-label li a img {\r\n    padding: 7px 0 0 10px;\r\n    float: right;\r\n}\r\n\r\n.request-form .form-btn {\r\n    text-align: right;\r\n    border-top: 1px solid #ccc;\r\n    padding: 20px 0;\r\n    margin: 20px 0 0;\r\n}\r\n\r\n.request-form .form-btn .btn {\r\n    border-radius: 100px;\r\n    padding: .375rem 25px;\r\n}\r\n\r\n.search-bx h5 {\r\n    font-size: 18px;\r\n    text-transform: uppercase;\r\n    color: #fff;\r\n    font-weight: 600;\r\n}\r\n\r\n.search-bx .modal-header {\r\n    background: #679BD3;\r\n}\r\n\r\n.search-bx .modal-content {\r\n    border: none;\r\n    border-radius: 5px;\r\n}\r\n\r\n.search-bx .modal-header span {\r\n    color: #fff;\r\n    opacity: 1;\r\n    font-size: 30px;\r\n    font-weight: normal;\r\n    margin: -3px 0 0 0;\r\n    display: block;\r\n}\r\n\r\n.search-bx .close {\r\n    opacity: 1;\r\n}\r\n\r\n.approval-popup {\r\n    text-align: center;\r\n    padding: 35px 55px;\r\n    font-weight: 400;\r\n}\r\n\r\n.approval-popup p {\r\n    font-size: 15px;\r\n    color: #323232;\r\n}\r\n\r\n.search-bx .modal-footer .btn {\r\n    border-radius: 100px;\r\n    padding: .375rem 25px;\r\n}\r\n\r\n.app-bx .search-heading h3 {\r\n    text-transform: capitalize;\r\n}\r\n\r\n.app-bx .rq_inf_box span {\r\n    text-align: left;\r\n    font-size: 16px !important;\r\n    color: #808080;\r\n    font-weight: 600;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.app-bx .rq_inf_box p {\r\n    text-align: left;\r\n    font-size: 14px !important;\r\n    color: #323232;\r\n    font-weight: 600;\r\n}\r\n\r\n.pen-appoval table.dataTable.display thead th:nth-child(1),\r\n.pen-appoval table.dataTable.display tbody td:nth-child(1) {\r\n    min-width: 220px;\r\n}\r\n\r\n.pen-appoval table.dataTable.display thead th:nth-child(3),\r\n.pen-appoval table.dataTable.display tbody td:nth-child(3) {\r\n    min-width: 120px;\r\n}\r\n\r\n.pen-appoval table.dataTable.display thead th,\r\n.pen-appoval table.dataTable.display tbody td {\r\n    text-align: left;\r\n}\r\n\r\n.pen-appoval table.dataTable.display tbody td:last-child {\r\n    text-align: left;\r\n}\r\n\r\n.doc-label.lw-25 li {\r\n    width: 25%;\r\n}\r\n\r\n.tabs-05 .col-xl-2 {\r\n    -ms-flex: 0 0 20%;\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n}\r\n\r\n.form-btn.text-rht {\r\n    text-align: right;\r\n}\r\n\r\n.error-msg .form-control {\r\n    border: 1px solid #f03004;\r\n}\r\n\r\n.error-msg span {\r\n    font-size: 12px;\r\n    color: #f03004;\r\n    text-align: left;\r\n}\r\n\r\n.footer-bg {\r\n    text-align: center;\r\n    padding: 20px 0;\r\n}\r\n\r\n.footer-bg ul li {\r\n    display: inline-block;\r\n    font-size: 14px;\r\n}\r\n\r\n.footer-bg ul li a {\r\n    border-right: 1px solid #323232;\r\n    padding: 0 12px 0 8px;\r\n    line-height: 15px;\r\n    display: block;\r\n    font-size: 14px;\r\n    color: #323232;\r\n}\r\n\r\n.footer-bg ul li:last-child {\r\n    padding: 0 0 0 8px;\r\n}\r\n\r\n@media (min-width: 1450px) {\r\n    .dbtabs  .master-data .nav-tabs li a h4 {\r\n        font-size: 16px;\r\n    }\r\n    .master-data .nav-tabs li a span {\r\n        font-size: 30px;\r\n    }\r\n    /* .master-data .nav-tabs li:nth-child(6) a h4 {\r\n        padding: 0px 0px 0 45px;\r\n    } */\r\n    /* .master-data .tabs-06 .nav-tabs li:nth-child(4) a h4 {\r\n        padding: 10px 0px 0 10px;\r\n    } */\r\n    .search-box {\r\n        position: relative;\r\n        width: 80%;\r\n    }\r\n    .search-heading .btn {\r\n        width: auto;\r\n    }\r\n    .upload-btn {\r\n        width: 55%;\r\n    }\r\n    form label {\r\n        font-size: 16px !important;\r\n    }\r\n    /* .search-user form .form-group img {\r\n        top: 40px;\r\n    } */\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .tabs-05 .col-lg-4 {\r\n        -ms-flex: 0 0 33.333333%;\r\n        flex: 0 0 33.333333%;\r\n        max-width: 33.333333%;\r\n    }\r\n\r\n    .breadcrumb li {\r\n        font-size: 15px;\r\n    }\r\n    .form-btn .btn {\r\n        font-size: 15px;\r\n        margin: 0 0 0 3px;\r\n    }\r\n    .request-form .form-btn .btn {\r\n        padding: .375rem 15px;\r\n    }\r\n    .search-user form .form-btn.pos-ablt {\r\n        position: relative;\r\n        right: 0;\r\n        bottom: 0;\r\n        text-align: right\r\n    }\r\n}\r\n\r\n@media (max-width: 990px) {\r\n    .user-profile .col-6.pr-0 {\r\n        -ms-flex: 0 0 10% !important;\r\n        flex: 0 0 10% !important;\r\n        max-width: 10% !important;\r\n    }\r\n    .sam-table > table {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n    }\r\n    .tabs-row .col-lg-2 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .search-user .col-lg-3 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .out-form .col-lg-2 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .out-form .col-lg-4 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .search-user form .form-btn {\r\n        position: relative !important;\r\n        right: 0 !important;\r\n        bottom: 0 !important;\r\n    }\r\n    .search-box {\r\n        position: relative;\r\n        width: 60%;\r\n    }\r\n    .out-form .form-check.pt-4.mt-3 {\r\n        margin-top: 0 !important;\r\n        padding-top: 0 !important;\r\n    }\r\n    .request-form .form-btn .btn {\r\n        width: 100%;\r\n        margin-bottom: 15px;\r\n    }\r\n    .search-heading .search-button {\r\n    min-width: 300px;\r\n}\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .sam-table > table {\r\n        display: block;\r\n        width: 100%;   \r\n        overflow-x: auto;\r\n    }\r\n    .header-bg h1 {\r\n        font-size: 16px;\r\n        padding-right: 65px;\r\n    }\r\n    .author-name,\r\n    .form-btn {\r\n        text-align: center;\r\n        float: none !important;\r\n    }\r\n    .header-bg {\r\n        height: 70px;\r\n        box-shadow: 10px 4px 16px 0 rgba(167, 175, 183, 0.33);\r\n    }\r\n    .user-heading h3 {\r\n        font-size: 20px;\r\n    }\r\n    .search-user form .form-group {\r\n        margin: 0 0 20px;\r\n    }\r\n    .check-box .col-form-label {\r\n        flex: 0 0 26%;\r\n        max-width: 26%;\r\n        text-align: left;\r\n    }\r\n    .reports-bx {\r\n        margin-bottom: 30px;\r\n    }\r\n    .col-form-label {\r\n        text-align: left !important;\r\n    }\r\n    .data-cnt .col-sm-3 {\r\n        -ms-flex: 0 0 41.666667%;\r\n        flex: 0 0 41.666667%;\r\n        max-width: 41.666667%;\r\n    }\r\n    .data-cnt .pl-0 {\r\n        padding-left: 15px!important;\r\n    }\r\n    .search-user form {\r\n        padding: 30px 5px;\r\n    }\r\n    .sam-table {\r\n        padding: 5px 15px;\r\n    }\r\n    .mob-width {\r\n        -ms-flex: 0 0 25%;\r\n        flex: 0 0 25%;\r\n        max-width: 25%;\r\n    }\r\n    .tabs-row .col-lg-2 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .tabs-row.tabs-06 .col-lg-2 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .search-user form .form-btn {\r\n        position: relative !important;\r\n        right: 0 !important;\r\n        bottom: 0 !important;\r\n    }\r\n    .search-heading h3 {\r\n        margin-bottom: 20px;\r\n    }\r\n    .total-record {\r\n        width: 15%;\r\n    }\r\n    .tabs-05 .col-lg-4 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n    .file-Upload {\r\n        margin-bottom: 20px;\r\n    }\r\n    .doc-label li a {\r\n        margin: 3px 12px 12px 0px;\r\n    }\r\n    .request-form figure {\r\n        display: none;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    table.dataTable.display tbody td {\r\n        min-width: 165px;\r\n    }\r\n    table.dataTable.display tbody td:nth-child(2),\r\n    table.dataTable.display tbody td:nth-child(3) {\r\n        min-width: 200px;\r\n    }\r\n    .footer-bg ul li {\r\n        padding: 0 0 10px;\r\n    }\r\n    .form-btn .btn {\r\n        margin: 0 15px 10px 0;\r\n        width: 100%;\r\n    }\r\n    .master-data .nav-tabs li a {\r\n        padding: 20px 10px;\r\n        font-size: 16px;\r\n        min-width: 300px;\r\n    }\r\n    .master-data .nav-tabs li {\r\n        padding: 0 0 5px;\r\n        width: 100%;\r\n    }\r\n    .text-color {\r\n        text-align: left;\r\n        padding: 10px 0;\r\n    }\r\n    .user-heading.yellow-bx .form-group {\r\n        margin-bottom: 10px;\r\n        margin-top: 15px;\r\n    }\r\n    .reports-bg {\r\n        padding-left: 1rem;\r\n        padding-right: 1rem\r\n    }\r\n    .user-heading h3 {\r\n        font-size: 18px;\r\n    }\r\n    .inner-heading p {\r\n        text-align: left;\r\n    }\r\n    .master-data .nav-tabs li:last-child a h4 {\r\n        padding: 10px 0px 0 25px;\r\n    }\r\n    .master-data .nav-tabs li a h4 {\r\n        padding: 10px 0;\r\n    }\r\n    .user-profile figure {\r\n        text-align: left;\r\n    }\r\n    .user-profile .col-6.pl-0 {\r\n        -ms-flex: 0 0 80%;\r\n        flex: 0 0 80%;\r\n        max-width: 80%;\r\n    }\r\n    .breadcrum-menu {\r\n        float: left;\r\n    }\r\n    .breadcrumb li {\r\n        font-size: 12px;\r\n    }\r\n    .breadcrumb-item+.breadcrumb-item::before {\r\n        height: 9px;\r\n    }\r\n    .inner-heading {\r\n        padding: 0 0 10px;\r\n    }\r\n    .doc-label {\r\n        margin-top: 20px;\r\n    }\r\n    .request-form figure {\r\n        text-align: center;\r\n    }\r\n    .doc-label li {\r\n        width: 100%;\r\n    }\r\n    .request-form form {\r\n        padding: 0px 5px 30px;\r\n    }\r\n    .doc-label li a {\r\n        margin: 3px 0px 12px 0px;\r\n    }\r\n    .search-heading.mp-1 {\r\n        padding-bottom: 0;\r\n    }\r\n    .approval-popup {\r\n        padding: 35px 25px;\r\n    }\r\n    .no-approve label {\r\n        margin: 0 0 5px;\r\n    }\r\n    .pen-appoval table.dataTable.display thead th:nth-child(4),\r\n    .pen-appoval table.dataTable.display tbody td:nth-child(4) {\r\n        min-width: 400px;\r\n    }\r\n    .master-data .nav-tabs li:nth-child(5) a h4 {\r\n        padding: 10px 0px 0 10px;\r\n    }\r\n    .out-form .form-check.pt-4.mt-3 {\r\n        margin-top: 0 !important;\r\n        padding-top: 0 !important;\r\n    }\r\n    .navbar.default-layout .navbar-menu-wrapper {\r\n        /* width: calc(100% - 75px) !important; */\r\n    }\r\n    .navbar.default-layout .navbar-menu-wrapper.collapsed {\r\n        /* width: calc(100% - 130px) !important; */\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .search-user {\r\n        padding: 20px 5px;\r\n    }\r\n    .search-box {\r\n        width: 100%;\r\n        margin-bottom: 5px;\r\n        position: relative;\r\n    }\r\n    .search-heading .form-control {\r\n        font-size: 14px;\r\n    }\r\n    .search-heading h3 {\r\n        font-size: 18px;\r\n    }\r\n    .add-user {\r\n        float: none !important;\r\n        padding: 15px 0px 15px 0px;\r\n    }\r\n    .header-bg h1 {\r\n        padding: 0;\r\n        /* font-size: 12px; */\r\n    }\r\n    .check-box {\r\n        margin: 0 !important;\r\n    }\r\n    .check-box label {\r\n        text-align: left;\r\n        width: 50%;\r\n        float: left;\r\n    }\r\n    .check-box .col-sm-4.pl-0 {\r\n        width: 40%;\r\n        float: left;\r\n    }\r\n    .author-name span {\r\n        display: none;\r\n    }\r\n    .form-btn {\r\n        padding: 20px 0;\r\n        text-align: left;\r\n    }\r\n    .check-box .col-form-label {\r\n        flex: 0 0 50%;\r\n        max-width: 50%;\r\n        text-align: left;\r\n    }\r\n    .modal .form-btn {\r\n        text-align: center;\r\n    }\r\n    .mob-width {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        flex: 0 0 100%;\r\n    }\r\n    .total-record {\r\n        width: 25%;\r\n    }\r\n    .navbar.default-layout .navbar-menu-wrapper {\r\n        width: auto\r\n    }\r\n    .user-profile .col-6.pr-0 {\r\n        -ms-flex: 0 0 20% !important;\r\n        flex: 0 0 20% !important;\r\n        max-width: 20% !important;\r\n    }\r\n    .navbar.default-layout .navbar-menu-wrapper {\r\n        width: calc(100% - 100px) !important;\r\n    }\r\n    .navbar.default-layout .navbar-menu-wrapper.collapsed {\r\n        width: calc(100% - 200px) !important;\r\n    }\r\n\r\n}\r\n\r\n.ms-BasePicker-itemsWrapper{\r\ndisplay:flex !important;\r\npadding: 0px 0 0 !important;\r\n}\r\nbutton.ms-Button.ms-Button--icon.ms-PickerItem-removeButton{\r\nmin-width:0em !important;\r\n}\r\nspan.ms-Button-flexContainer{\r\npadding:0px 0 0 !important;\r\ndisplay:flex !important;\r\ncolor:black;\r\n}\r\n\r\n\r\nbutton:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  @media (min-width: 992px) {\r\n    /* .navbar .navbar-brand-wrapper {\r\n        width: 70px;\r\n    }\r\n    .navbar .navbar-menu-wrapper {\r\n        width: calc(100% - 70px);\r\n    } */\r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper .brand-logo-mini img {\r\n    width: 50px;\r\n    max-width: 100%;\r\n    margin: auto;\r\n}\r\n#smalllogo {\r\n    display: inline-block;\r\n}\r\n@media (min-width: 992px) {\r\n    .sidebar-icon-only .navbar .navbar-brand-wrapper .brand-logo-mini {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        margin-right: 0px;\r\n    }\r\n    \r\n}\r\n\r\n.navbar.default-layout .navbar-brand-wrapper.collapsed {\r\n    width: 70px !important;\r\n  }\r\n  \r\n  .navbar.default-layout .navbar-menu-wrapper.collapsed {\r\n    width: calc(100% - 75px) !important;\r\n  }\r\n  \r\n  .navbar.default-layout .navbar-brand-wrapper.collapsed {\r\n  margin-left: 5px;\r\n  }\r\n\r\n  .navbar.default-layout .navbar-brand-wrapper {\r\n  margin-left: 30px;\r\n  }\r\n  \r\n  .navbar.default-layout .navbar-menu-wrapper {\r\n        width: calc(100% - 270px);\r\n        \r\n  }\r\n  .navbar-expand .navbar-toggler {\r\n    display: block !important;\r\n}\r\n.spinner-border {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    vertical-align: middle;\r\n  }\r\n  .thin-spinner {\r\n    border-width: 2px !important; /* Adjust thickness */\r\n  }\r\n\r\n  .sidebar li.nav-item a.nav-link{\r\n    height: 55px ;\r\n  }\r\n\r\n  .sidebar li.has-submenu > a.nav-link {\r\n    height: 55px;\r\n  }\r\n\r\n.submenu-container .nav-link.hieght35,\r\n.sub-submenu-container .nav-link.hieght35 {\r\n    height: 40px !important;\r\n}\r\n\r\nli.has-submenu:has(.menu-label:contains(\"Archive\")) .submenu-container .nav-link svg.me-2 {\r\n    display: none;\r\n}\r\n\r\n@media screen and (min-device-width: 478px) and (max-device-width: 580px) { \r\n.navbar.default-layout .navbar-menu-wrapper {\r\n    width: auto; \r\n     margin-right: 20px;\r\n}\r\n\r\n\r\n}\r\n@media (max-width: 991px) {\r\n     .onSmallScreen{\r\n         display: none; \r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .d-lg-none {\r\n         display: none !important; \r\n    }\r\n    .onSmallerOnlyButton {\r\n    position: absolute;\r\n    right: 60px;\r\n}\r\n}\r\n\r\n@media (max-width: 190px) {\r\n    .d-lg-none{\r\n        display: none;\r\n    }\r\n\r\n}\r\n@media (max-width: 490px) {\r\n    .header-bg h1 {\r\n      display: none;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
